import { createListenerMiddleware } from '@reduxjs/toolkit';
import TagManager from '@sooro-io/react-gtm-module';
import { CookieHub } from 'react-cookiehub';
import { REHYDRATE } from 'redux-persist';

import { AppDispatch, RootState } from '.';
import { login, logout } from './auth';

export const trackingMiddleware = createListenerMiddleware();

const startAppListening = trackingMiddleware.startListening.withTypes<
  RootState,
  AppDispatch
>();

startAppListening({
  type: REHYDRATE,
  effect: (_action, listenerApi) => {
    const {
      auth: { user }
    } = listenerApi.getState();
    if (user) {
      const { id } = user;
      if (CookieHub.hasConsented('analytics')) {
        TagManager.dataLayer({ dataLayer: { user_id: id } });
      }
    }
  }
});

startAppListening({
  actionCreator: login,
  effect: action => {
    const {
      user: { id }
    } = action.payload;
    if (CookieHub.hasConsented('analytics')) {
      TagManager.dataLayer({ dataLayer: { user_id: id } });
    }
  }
});

startAppListening({
  actionCreator: logout,
  effect: () => {
    TagManager.dataLayer({ dataLayer: {} });
  }
});
